import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {StartupService} from "../service/startup.service";

@Injectable({
  providedIn: 'root',
})
export class ErrorGuard {
  constructor(private readonly router: Router, private readonly startupService: StartupService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!(this.startupService.hasFailed || this.startupService.isStarted)) {
      return this.router.createUrlTree(['/']);
    }
    // route to error page if there was an error in the startup or if the error occurred after the startup
    return true;
  }
}
